import { useQuery } from "@tanstack/react-query";
import { createFileRoute } from "@tanstack/react-router";

import {
  AcquisitionBox,
  ActivityBox,
  DailyActivityBox,
  GrowthCharts,
  GrowthTables,
  SignInsBox,
} from "../components/admin/growth";
import { Grid, Pending, useAdminDays } from "../components/admin/retro";
import { adminSignInsQuery, adminStatsQuery } from "../lib/queries";

export const Route = createFileRoute("/_authed/admin/croissance")({
  component: GrowthPage,
});

function GrowthPage() {
  const days = useAdminDays();
  const stats = useQuery(adminStatsQuery(days));
  const signIns = useQuery(adminSignInsQuery(days));
  if (!stats.data) return <Pending query={stats} />;
  return (
    <div className={stats.isPlaceholderData ? "opacity-60" : undefined}>
      <Grid>
        <ActivityBox stats={stats.data} className="md:col-span-2 xl:col-span-3" />
        <AcquisitionBox stats={stats.data} />
        {signIns.data && <SignInsBox signIns={signIns.data} />}
        <GrowthCharts stats={stats.data} />
        <GrowthTables stats={stats.data} />
        <DailyActivityBox stats={stats.data} />
      </Grid>
    </div>
  );
}
